import { useMemo } from 'react';
import PdfPreview from 'components/ShareDocument/SharePreviewContent/PdfPreview';
import DocxPreview from 'components/ShareDocument/SharePreviewContent/DocxPreview';
import ImagePreview from 'components/ShareDocument/SharePreviewContent/ImagePreview';
import OfficePreview from 'components/ShareDocument/SharePreviewContent/OfficePreview';
import UnsupportedPreview from 'components/ShareDocument/SharePreviewContent/UnsupportedPreview';
import {
  IMAGE_PREVIEW_EXTENSIONS,
  OFFICE_PREVIEW_EXTENSIONS,
  SharePreviewProps,
  getFileExtension,
} from 'components/ShareDocument/SharePreviewContent/sharePreviewHelpers';

export {
  getFileExtension,
  getOfficePreviewEmbedUrl,
} from 'components/ShareDocument/SharePreviewContent/sharePreviewHelpers';

const SharePreviewContent = ({ url, filename, barBackgroundColor, logo }: SharePreviewProps) => {
  const extension = useMemo(() => getFileExtension(filename, url), [filename, url]);
  const previewProps = { url, filename, barBackgroundColor, logo };
  if (extension === 'pdf') {
    return <PdfPreview />;
  }

  let body = <UnsupportedPreview />;
  const isImage = IMAGE_PREVIEW_EXTENSIONS.includes(extension);
  if (extension === 'docx') {
    body = <DocxPreview {...previewProps} />;
  } else if (isImage) {
    body = <ImagePreview {...previewProps} />;
  } else if (OFFICE_PREVIEW_EXTENSIONS.includes(extension)) {
    body = <OfficePreview {...previewProps} />;
  }

  return (
    <div className='rounded border-general border-grey-50'>
      <div
        className={`attachment-preview-height-container${isImage ? ' attachment-preview-height-container--image' : ''}`}
      >
        {body}
      </div>
    </div>
  );
};

export default SharePreviewContent;
